import { Component, Input } from '@angular/core';
import { SacSelection } from '../../../model/sac-client.model';

@Component({
  selector: 'app-mobile-station-details',
  templateUrl: './station-details.component.html',
  styleUrls: ['./station-details.component.scss']
})
export class MobileStationDetailsComponent {

  @Input() selection: SacSelection;

  selectedTab: string = 'details';

  selectTab(tab: string) {
    this.selectedTab = tab;
  }
}
